import React, { Component, Fragment } from "react";
import request, { NodeURL } from "../../../src/api/api";
import { Row, InputGroupAddon, InputGroupText, CardBody, Col, Button } from "reactstrap";
import { AvFeedback, AvForm, AvGroup, AvInput } from "availity-reactstrap-validation";
import { toast, ToastContainer } from "react-toastify";

class forgotpassword extends Component {
  state = {
    logo_loder : false,
    agency_company_logo : '',
    agency_company_name : '',
    newpassword: "",
    confirmnewpassword: ""
  };

  componentDidMount = () => {
    const subdomain = window.location.host.split(".")[1] ? window.location.host.split(".")[0] : false;
    request({
      url: "/site/agencies",
      method: "POST",
    }).then((res) => {
      this.setState({ logo_loder: true });
      const filteredlist = res.response.result && res.response.result.filter((list) => list.domain.toString() === subdomain.toString());
      this.setState({ agency_company_logo: filteredlist && filteredlist[0] && filteredlist[0].company_logo, agency_company_name: filteredlist && filteredlist[0] && filteredlist[0].company_name }, () => {
        this.setState({ logo_loder: false });
      });
    })
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  OnFormSubmit = e => {
    if (this.props && this.props.match && this.props.match.params && this.props.match.params.id && this.props.match.params.resetcode) {
      request({
        url: `/candidate/resetpassword/${this.props.match.params.id}/${this.props.match.params.resetcode}`,
        method: "POST",
        data: { password: this.state.newpassword, confirmpassword: this.state.confirmnewpassword }
      }).then(res => {
        if (res.status === 1) {
          toast.success(res.response);
          setTimeout(() => {
            return  this.props.history.push({ pathname: "/login" });
          }, 3000);
        } else if (res.status === 0) {
          toast.error(res.response);
        }
      }).catch(err => {
        this.logerror();
      });
    } else {
      toast.info('Unable to get data');
      setTimeout(() => {
        return  this.props.history.push({ pathname: "/login" });
      }, 2000);
    }
  };

  render() {
    return (
      <>
        <Fragment>
          <ToastContainer position="top-right" autoClose={2500} closeOnClick />
          <div className="page-wrapper">
            <div className="container-fluid">
              {/* <!-- Reset Password page start--> */}
              <div className="authentication-main">
                <div className="row">
                  <div className="col-md-12 p-0">
                    <div className="auth-innerright">
                      <div className="authentication-box">
                        <div className="text-center new-agency-login"><img src={this.state.agency_company_logo && this.state.agency_company_logo.length > 0 ? `${NodeURL}/${this.state.agency_company_logo}` : null} alt="" /></div>
                        <div className="card mt-4 p-4">
                          <form className="theme-form">
                            <h5 className="f-16 mb-3 f-w-600">CREATE YOUR PASSWORD</h5>
                            <AvForm onValidSubmit={this.OnFormSubmit}>
                              <CardBody>
                                <AvGroup className="input-group">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                      <i className="icon-lock" />
                                    </InputGroupText>
                                  </InputGroupAddon>
                                  <AvInput lable="New Password" type="password" name="newpassword" placeholder="Enter new password" onChange={this.onChange} value={this.state.newpassword} required />
                                  <AvFeedback>Password is required!</AvFeedback>
                                </AvGroup>
                                <AvGroup className="input-group">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                      <i className="icon-lock" />
                                    </InputGroupText>
                                  </InputGroupAddon>
                                  <AvInput type="password" name="confirmnewpassword" placeholder="Enter confirm new password" onChange={this.onChange} value={this.state.confirmnewpassword} required validate={{ match: { value: "newpassword" } }} />
                                  <AvFeedback>Confirm Password is required!</AvFeedback>
                                </AvGroup>
                              </CardBody>
                              <div className="form-group form-row mb-0">
                                <div className="col-md-2">
                                  <button className="btn btn-primary" type="submit">Submit</button>
                                </div>
                              </div>
                            </AvForm>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Reset Password page end--> */}
            </div>
          </div>
        </Fragment>
      </>
    );
  }
}

export default forgotpassword;
